<script lang="ts" setup>
import { definePageMeta, useSeoMeta, ref } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { FreshTasksService } from './components/index/FreshTasks/FreshTasks.service';
import { ZoneService } from '~/services/zone.service';
import BannerSwiper from './components/index/BannerSwiper.vue';
import ContestCountdown from './components/index/ContestCountdown.vue';
import FreshTasks from './components/index/FreshTasks/FreshTasks.vue';
import FriendlyLinks from './components/index/FriendlyLinks.vue';
import HotContests from './components/index/HotContests/HotContests.vue';
import LastUnfinished from './components/index/LastUnfinished.vue';
import ProblemRecommends from './components/index/ProblemRecommends/ProblemRecommends.vue';
import SeriesTraining from './components/index/SeriesTrainingV2.vue';
import UserGuideEntry from './components/index/UserGuideEntry.vue';
import WeeklyGoods from './components/index/WeeklyGoods/WeeklyGoods.vue';
import { useFreshTasksPlacement } from '~/composables/use-fresh-tasks-placement';

definePageMeta({
  name: 'index',
  key: (route) => route.name as string,
  layout: 'nav-oj',
});

declareProviders([FreshTasksService]);
const zoneService = useService(ZoneService);
const freshTasksService = useService(FreshTasksService);
const { isPriority } = useFreshTasksPlacement(()=>freshTasksService.noviceTasks.noviceType);

useSeoMeta({
  title: '核桃OJ',
});
</script>

<template>
  <div v-track:newoj_homepage_show class="index-container">
    <div class="container mt-4 flex items-start justify-between">
      <div class="w-[848px]">
        <UserGuideEntry />
        <SeriesTraining class="mt-4" />
        <HotContests class="mt-4" />
        <ProblemRecommends class="mt-4" />
      </div>
      <div class="flex w-[308px] flex-col">
        <BannerSwiper />
        <ContestCountdown v-if="zoneService.zone === 'cpp'" class="mt-4" />
        <template v-if="isPriority">
          <FreshTasks class="mt-4" />
        </template>
        <WeeklyGoods class="mt-4" />
        <LastUnfinished class="mt-4" />
        <template v-if="!isPriority">
          <FreshTasks class="mt-4" />
        </template>
        <FriendlyLinks class="mt-4" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.index-container {
  background: url(~/assets/image/index/bg-footer2.svg) center bottom no-repeat;
  background-size: 620px;
  margin-bottom: -70px;
  padding-bottom: 56px;
}
</style>
